import {
  css,
} from 'styled-components/macro';
import theming from 'styled-theming';
import {
  theme,
} from '../../../utilsClient/cssHelpers';

const getAbsoluteFontSize = (props) => {
  switch (props.size) {
    case 'xs':
      return theme('font.size.xs')(props);
    case 'small':
      return theme('scale.-1')(props);
    case 'large':
      return theme('font.size.large')(props);
    default:
      return null;
  }
};

const getRelativeFontSize = (props) => {
  switch (props.size) {
    case 'small':
      return theme('font.size.smaller')(props);
    case 'large':
      return theme('font.size.larger')(props);
    default:
      return null;
  }
};

const stylesImportanceHigh = theming('mode', {
  light: css`
    font-weight: ${theme('font.weight.bold')};
  `,
  dark: css`
    font-weight: ${theme('font.weight.bold')};
    color: rgba(255, 255, 255, 1);
  `,
});

const stylesImportanceLow = theming('mode', {
  light: css`
    color: rgba(0, 0, 0, 0.65);
  `,
  dark: css`
    color: rgba(255, 255, 255, 0.65);
  `,
});

const getImportance = (props) => {
  switch (props.importance) {
    case 'high':
      return stylesImportanceHigh;
    case 'low':
      return stylesImportanceLow;
    default:
      return null;
  }
};

const getTransform = (props) => {
  switch (props.transform) {
    case 'uppercase':
      return `
        text-transform: uppercase;
        letter-spacing: 0.05em;
      `;
    default:
      return null;
  }
};

const getType = (props) => {
  switch (props.type) {
    case 'primary':
      return theme('color.primary')(props);
    case 'danger':
      return theme('color.danger')(props);
    case 'warning':
      return theme('color.warning')(props);
    case 'success':
      return theme('color.success')(props);
    default:
      return null;
  }
};

const styles = css`
  ${props => getImportance(props)};
  ${props => getTransform(props)};

  color: ${props => getType(props)};
  text-align: ${props => props.align};

  strong {
    ${stylesImportanceHigh}
  }
`;

const absoluteStyles = css`
  ${styles};

  font-size: ${props => getAbsoluteFontSize(props)};
`;

const relativeStyles = css`
  ${styles};

  font-size: ${props => getRelativeFontSize(props)};
`;

const colorStyles = css`
  /* ${props => `color: hsla(${theme('color.darkBase')(props)}, 0.8)`}; */
`;

export {
  absoluteStyles,
  relativeStyles,
  colorStyles,
};
